import { useState } from "react";
import { api } from "../lib/api";
import { useAuth } from "../lib/auth";

export default function Account() {
  const { user } = useAuth();
  const [form, setForm] = useState({ current: "", next: "", next2: "" });
  const [state, setState] = useState<"idle" | "busy" | "done" | "error">("idle");
  const [err, setErr] = useState("");

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setErr("");
    if (form.next !== form.next2) return setErr("새 비밀번호 확인이 일치하지 않습니다.");
    if (form.next.length < 8) return setErr("새 비밀번호는 8자 이상이어야 합니다.");
    if (form.current === form.next) return setErr("기존과 동일한 비밀번호는 사용할 수 없습니다.");
    setState("busy");
    try {
      await api.post("/auth/change-password", { current: form.current, next: form.next });
      setState("done");
      setForm({ current: "", next: "", next2: "" });
    } catch (e: any) {
      setErr(e.message);
      setState("error");
    }
  };

  return (
    <main id="main-content" className="container" style={{ padding: "var(--s-8) var(--s-5)", maxWidth: 520 }}>
      <h1 className="h-title" style={{ marginBottom: "var(--s-5)" }}>내 계정</h1>

      <section className="card" style={{ padding: "var(--s-6)", marginBottom: "var(--s-4)" }}>
        <h3 className="h-section">계정 정보</h3>
        <dl className="stack" style={{ gap: 8, fontSize: 15 }}>
          <Row label="이메일" value={user?.email} />
          <Row label="업체명" value={user?.company_name} />
          <Row label="권한" value={user?.role === "admin" ? "관리자" : "일반 회원"} />
          <Row label="등급" value={user?.tier} />
        </dl>
      </section>

      <section className="card" style={{ padding: "var(--s-6)" }}>
        <h3 className="h-section">비밀번호 변경</h3>
        <form onSubmit={submit} className="stack">
          <Field label="현재 비밀번호" type="password" value={form.current} onChange={(v) => setForm({ ...form, current: v })} autoComplete="current-password" />
          <Field label="새 비밀번호 (8자 이상)" type="password" value={form.next} onChange={(v) => setForm({ ...form, next: v })} autoComplete="new-password" />
          <Field label="새 비밀번호 확인" type="password" value={form.next2} onChange={(v) => setForm({ ...form, next2: v })} autoComplete="new-password" />
          {err && <div style={{ padding: 10, background: "var(--danger-soft)", color: "var(--danger)", borderRadius: 4, fontSize: 15 }}>{err}</div>}
          {state === "done" && <div style={{ padding: 10, background: "var(--success-soft)", color: "var(--success)", borderRadius: 4, fontSize: 15 }}>비밀번호가 변경되었습니다. 다른 기기의 세션은 자동 로그아웃 처리되었습니다.</div>}
          <button className="btn btn-primary" disabled={state === "busy"}>{state === "busy" ? "변경 중..." : "비밀번호 변경"}</button>
        </form>
      </section>
    </main>
  );
}

function Row({ label, value }: { label: string; value?: string }) {
  return (
    <div style={{ display: "flex", justifyContent: "space-between", padding: "6px 0", borderBottom: "1px solid var(--border)" }}>
      <dt className="muted">{label}</dt>
      <dd style={{ margin: 0, fontWeight: 500 }}>{value ?? "—"}</dd>
    </div>
  );
}

function Field({ label, type, value, onChange, autoComplete }: { label: string; type: string; value: string; onChange: (v: string) => void; autoComplete?: string }) {
  return (
    <label>
      <div style={{ fontSize: 15, fontWeight: 600, marginBottom: 6 }}>{label}</div>
      <input required type={type} value={value} onChange={(e) => onChange(e.target.value)} autoComplete={autoComplete} />
    </label>
  );
}
